<template>
  <span>
    <span class="text-xs italic" v-if="revision === 'pending'">{{$t('messages.general.revision_pending')}}</span>
    <span v-else>{{value}}</span>
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "IsRevisionPending",
  props: ['value', 'revision'],
};
</script>
